module.exports = __webpack_public_path__ + "static/media/06.4f35c1eb.png";